import { Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { assignRoleToUser, getRoles } from "../../../../../../../api/apiCall";
import { useAuth } from "../../../../../../../auth/auth";
import { toast } from "react-toastify";

const AddRole = ({userId, getAllUserRoles, setOpen}: any) => {
    const {state} = useAuth();
    const [roles, setRoles] = useState<any>([]);
    const [roleId, setRoleId] = useState<any>()

    const getAllRoles = async () => {
        const response = await getRoles(state.user?.token);
        setRoles(response)
    };

    const assignRole = async () => {
        const response: any = await assignRoleToUser(state.user?.token, roleId, userId);
        if(response.status === 200) {
            getAllUserRoles();
            toast.success('Added Role Successfully!');
            setOpen(false);
        }
    }

    useEffect(() => {
        getAllRoles();
    }, []);

    return (
        <Box display="grid" gridTemplateColumns={{xs: "1fr", md: "1fr"}} gap={3}>
            <Typography fontWeight={"600"}>Add New Role</Typography>
            <TextField
                select
                value={roleId}
                label="Role"
                id="demo-select-small"
                size="small"
                fullWidth
                onChange={(e) => setRoleId(e.target.value)}
            >
                {roles.map((role: any) =>
                    <MenuItem key={role.id} value={role.id}>
                        {role.roleName}
                    </MenuItem>
                )}
            </TextField>
            <div className="center-button-div">
                <Button variant="contained" sx={{boxShadow: 'none', width: 150}} onClick={assignRole}>
                    Add Role
                </Button>
            </div>
        </Box>
    )
}

export default AddRole;
